import {apiUrl, dateFormat, alert, isEmptyObj} from '../helper'
import $ from 'jquery'
import myDatepicker from '../helper/datepicker.vue'

export default {
  components: {
    'date-picker': myDatepicker
  },
  data () {
    return {
      tagname: '',
      showModalTag: false,
      tagdata: {},
      tagclicked: false,
      tagLists: [],
      showtag: false,
      loading: false,
      onlyTitle: 0,  // 只显示标题
      page: 1,       // 分页
      total: 0,      // 数据总数
      perPage: 5,    // 每页显示数目
      totalPage: 0,  // 总页数
      detailLists: [],  // 数据
      newItems: [],     // 每次分页加载所获得的数据
      topPage: 0,       // 处于最顶部分页页码
      bottomPage: 0,    // 处于最底部分页页码
      sort: 1,   // 1：按相关性排序，2：按时间排序
      company: [],    // 公司
      showdownBtn: true,
      related_company: [],   // 关联公司
      related_name: [],      // 相关人名
      items: [],    // 搜索结果
      aggTypes: [],   // 公告类型
      aggPlates: [],  // 板块类型
      aggLabels: [],  // 公告标签
      checkedAll: false,  // 选择全部
      checkedCount: 0,    // 选中数目
      showSort: false,    // 按日期顺序显示
      showTongji: false,  // 统计
      showStatAnalyze: true,  // 统计分析
      showStatFilter: false,  // 统计筛选
      showDropdownMenu: '',   // 下拉框
      stypename: '',   // 搜索后分析搜索结果的title
      // --------------------------------------
      showSearchPage: false,    // 搜索结果
      showTongjiPage: false,    // 统计
      showResultPage: true,     // 搜索结果
      shownone: false,
      showDateModal: false,
      select_type: [],   // 选中的公告类型
      select_qaType: [], // 选中的问题类型
      select_plate: [],  // 选中的板块类型
      select_layer: [],  // 板块类型子类——挂牌公司
      select_region: [], // 选中的地区类型
      select_securityCompany: [], // 选中的主办券商
      select_industry: [],        // 选中的行业类型
      select_industrysecond: [],  // 选中的行业类型子类
      oldDatetype: 0,   // 默认日期类型
      oldStartdate: 0,  // 默认起始日期
      oldEnddate: 0,     // 默认终点日期
      // -----------------------------------------------------
      upanddown: 0,
      Amplitude: 0,
      timetyp: 1,
      smartComInfo: {},
      prices: {},
      finance: [],      // 按季度
      yearfinance: [],  // 按年度
      hasoneSearch: false,
      datepicker: {
        option: {
          type: 'day',
          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
          format: 'YYYY-MM-DD',
          placeholder: '',
          inputStyle: {
            'display': 'inline-block',
            'width': '100%',
            'padding': '4px 6px',
            'line-height': '22px',
            'font-size': '16px',
            'box-shadow': '0px 0px 0px 0px',
            // 'border-radius': '5px',
            'background': '#F2F2F2',
            'color': 'rgb(95, 95, 95)'
          },
          color: {
            header: '#00736a',
            headerText: '#ffffff'
          },
          buttons: {
            clear: '清空',
            today: '今天',
            ok: '确定',
            cancel: '取消'
          },
          overlayOpacity: 0.5, // 0.5 as default
          dismissible: true // as true as default
        }
      },
    }
  },
  computed: {
    totalPage () {
      let totalPage = Math.ceil(this.total / 5)
      return totalPage
    },
    indexs () {
      let left = 1
      let right = this.totalPage
      let ar = []
      if (this.totalPage >= 11) {
        if (this.page > 5 && this.page < this.totalPage - 4) {
          left = this.page - 5
          right = this.page + 4
        } else {
          if (this.page <= 5) {
            left = 1
            right = 10
          } else {
            right = this.totalPage
            left = this.page - 9
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    }
  },
  created: function () {
    this.getMeta()
  },
  ready () {
    this.$nextTick(function () {
      // 设置页面最低高度等于屏幕可是区域高度
      let innerHeight = window.innerHeight + 'px'
      $('.wrapper').css({'min-height': innerHeight})
    })
  },
  methods: {
    getTagLists: function () {
      $.ajax({
        url: apiUrl('/V1.0.0/user/taglist'),
        method: 'post',
        dataType: 'json'
      }).done((response) => {
        if (response.status === 0) {
           this.tagLists = response.data 
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    searchByTag: function (tagid) {
      $.ajax({
        url: apiUrl('/V1.0.0/user/gettag'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify({'id': tagid})
      }).done((response) => {
        if (response.status === 0) {
          if (parseInt(response.data['stype']) === this.stype) {
            this.searchByTagAfter(response.data)
          } else {
            let stype = parseInt(response.data['stype']) || 1
            this.tagdata = response.data
            this.tagclicked = true
            this.changeStype(stype)
          }
        } else if (response.status === 502) {
          alert('很抱歉，请求超时请重新搜索')
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    searchByTagAfter (data) {
      for (let i of this.industry) {
        i.count = 0
      }
      for (let j of this.plates) {
        j.count = 0
      }
      this.parseTagData(data)
      if (this.searched) {
        this.go()
      } else {
        for (let key in this.conditions) {
          if (!isEmptyObj(this.conditions[key])) {
            this.havelabels = true
            this.showMylabels = 2
            this.addToShow()
          }
        }
        for (let k of this.industry) {
          this.setNum('industrysecond', k)
        }
        for (let t of this.plates) {
          this.setNum('layer', t)
        }
      }
    },
    parseTagData (data) {
      for (let key in data['conditions']) {
        this.conditions[key] = data['conditions'][key]
      }

      this.ttype = parseInt(data['ttype']) || 0
      this.keywords = data['keywords'] || ''
      this.companyCode = data['companyCode'] || ''
      this.datetype = parseInt(data['datetype']) || 98
      if (this.datetype === 99) {
        this.startdate = data['startdate'] || ''
        this.enddate = data['enddate'] || ''
      } else {
        this.changeDateType(this.datetype)
      }
      this.keywords_condition = data['keywords_condition']
      for (let i of this.keywords_condition) {
        if (!i.hasOwnProperty('opname')) {
          let j = i
          j.opname = this.optypeMap[j.optype]
          j.ttname = this.ttypeMap[j.ttype]
          i = j
        }
      }
      this.ai = parseInt(data['ai']) || 0
      this.perPage = 10
      this.page = 1
      this.sort = 1
    },
    delTag (tagid) {
      $.ajax({
        url: apiUrl('/V1.0.0/user/deltag'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify({'id': tagid})
      }).done((response) => {
        if (response.status === 0) {
          this.getTagLists()
        }
      }).fail((response) => {
        alert('请求失败')
      })
      // this.setCnzz('删除标签', '点击删除图标删除标签')
    },
    saveTag: function () {
      this.keywords = this.keywords.trim()
      if (this.keywords === '' && !this.validKeywordCondition() && !this.companyCode) {
        alert('请输入关键词或者股票代码')
        return
      }
      let data = JSON.stringify(this.genTagData())
      let query = {'name': this.tagname, 'data': data}
      this.loading = true
      $.ajax({
        url: apiUrl('/V1.0.0/user/savetag'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          alert('保存成功')
          this.showModalTag = false
          this.tagname = ''
          this.getTagLists()
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    genTagData () {
      let query = {}
      query['conditions'] = this.conditions
      query['stype'] = this.stype
      query['ttype'] = this.ttype
      query['keywords'] = this.keywords
      query['companyCode'] = this.companyCode
      query['datetype'] = this.datetype
      query['startdate'] = this.startdate
      query['enddate'] = this.enddate
      query['keywords_condition'] = this.keywords_condition
      query['ai'] = this.ai
      return query
    },
    // 判断一个对象是否是空对象
    isEmptyObj (obj) {
      if (Object.keys(obj).length > 0) {
        return false
      }
      return true
    },
    // 初始化分析
    initAnaly () {
      this.company = []           // 相关公司
      this.related_company = []   // 提到的公司
      this.related_name = []      // 相关人名
      this.aggTypes = []   // 公告类型
      this.aggPlates = []  // 板块类型
      this.aggLabels = []  // 标签类型
    },
    /**
     * 自定义分页操作
     */
    paging2 (page) {
      let query = this.genQuery()
      query.page = page
      query.perPage = 5
      query.uid = parseInt(this.params.uidUrl)
      query.share = this.params.share
      query.plat = this.params.plat
      query.sid = this.params.sid
      let requrl = ''
      if (this.stype === 1 || this.stype === 2) {  // A股或新三板
        requrl = apiUrl('/V1.0.0/notice/searchn3b')
      } else {
        requrl = apiUrl('/V1.0.0/notice/search')
      }
      $.ajax({
        url: requrl,
        method: 'post',
        dataType: 'json',
        async: false,  // 同步
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        this.analyze()  // 分析
        if (response.status === 0) {
          let items = response.lists
          for (let item of items) {
            item.checked = false
            if (item.child) {
              for (let child of item.child) {
                child.showque = false
                if (child.answers) {
                  for (let ans of child.answers) {
                    ans.showans = false
                  }
                }
              }
            }
          }
          this.newItems = items
        } else if (response.status === 502) {
          alert('很抱歉，请求超时请重新搜索')
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
      })
    },
    reportPage2(page){
      console.log(page)
      console.log('打印翻译的页面')
      let query = this.genQuery()
      query.page = page
      query.perPage = 10
      query.uid = parseInt(this.params.uidUrl)
      query.share = this.params.share
      query.plat = this.params.plat
      query.sid = this.params.sid
      query.stypes = [this.stype]
      $.ajax({
        url: apiUrl('/V1.0.0/notice/searchall'),
        method: 'post',
        dataType: 'json',
        async: false,  // 同步
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          let items = response.data[this.stype].lists
          for (let item of items) {
            item.checked = false
            if (item.child) {
              for (let child of item.child) {
                child.showque = false
                if (child.answers) {
                  for (let ans of child.answers) {
                    ans.showans = false
                  }
                }
              }
            }
          }
          this.newItems = items
        } else if (response.status === 502) {
          alert('很抱歉，请求超时请重新搜索')
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
      })
    },
    /**
     * 分析
     */
    analyze () {
      let query = this.genQuery()
      let requrl = ''
      if (this.stype === 1 || this.stype === 2) {
        requrl = apiUrl('/V1.0.0/notice/analyzen3b')
      } else {
        requrl = apiUrl('/V1.0.0/notice/analyze')
      }
      $.ajax({
        url: requrl,
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          this.company = response.agg.company
          this.related_company = response.agg.related_company
          this.related_name = response.agg.related_name
          if (response.agg.type) {  // 公告类型
            this.aggTypes = []
            for (let agg of response.agg.type) {
              this.aggTypes.push({
                'code': agg.key,   // 公告名
                'name': agg.key,   // 公告名
                'count': agg.doc_count   // 公告数
              })
            }
          }
          if (response.agg.plate) {   // 板块类型
            let aggMap = {}
            for (let agg of response.agg.plate) {
              aggMap[agg.key] = agg.doc_count
            }
            this.aggPlates = []
            for (let t of this.plates) {
              if (aggMap[t.code]) {
                this.aggPlates.push({'code': t.code, 'name': t.name, 'count': aggMap[t.code]})
              }
            }
          }
          if (response.agg.labels) {  // 公告标签
            this.aggLabels = []
            for (let agg of response.agg.labels) {
              this.aggLabels.push({'code': agg.key, 'name': agg.key, 'count': agg.doc_count})
            }
          }
        } else if (response.status === 502) {
          console.log('很抱歉，请求超时请重新搜索')
        }
      }).fail((response) => {
        console.log('请求失败')
      })
    },
    /**
     * 搜索结果排序方式
     */
    selSort (val) {
      console.log(val)
      this.sort = val   // 1：按相关性排序，2：按时间排序
      this.showSort = false
      if (this.searched) {
        this.go()
      }
    },
    /**
     * 搜索结果根据日期过滤
     */
    sortByDate (val) {
      console.log(val)
      this.changeDateType(val)
      console.log(this.genUrlQuery());
      if (this.searched) {
        this.go()
      }
    },
    // 未登陆状态下，点击各种按钮直接进入登陆/注册页面
    checkLogin: function (item) {
      console.log(item)
      console.log('调用checkLogin函数')
      if (this.currentRegtyp === 4) {
        this.tipGoBind = true
        return
      }
      console.log(item)
      let url = ''
      if (item.viewtype === 2) {
        url = item.sourceurl
        window.location.href = url
        // window.location.href = this.viewUrl(item)
      } else {
        url = window.location.origin + this.viewUrl(item)
        console.log(url)
        window.location.href = url
      }
    },
    checkLoginQa: function (item) {
      console.log('调用checkLoginQa函数')
      // 未绑定微信
      if (this.currentRegtyp === 4) {
        this.tipGoBind = true
        return
      }
      console.log(item)
      console.log(this.qaViewUrl(item))
      let url = window.location.origin + this.qaViewUrl(item)
      console.log(url)
      if (item.viewtype === 2) {
        window.location.href = item.sourceurl
      } else {
        window.location.href = url
      }
    },
    // 打开ABS详情信息
    openAbsAnn: function (item) {
      console.log(item)
      console.log('进入ABS')
      if (this.currentRegtyp === 4) {
        this.tipGoBind = true
        return
      }
      let url = this.absviewUrl(item)
      
      if (!url) {
        alert('此链接无法打开')
        return false
      }
      let urlopen = window.location.origin + url;
      console.log(urlopen)
      window.location.href = urlopen;
      if (document.cookie.indexOf('embed=1') < 0) {
        window.open(url)
      } else {
        if (item.viewtype === 2) {
          window.open(url)
        } else {
          window.location.href = url
        }
      }
    },
    absviewUrl: function (item) {
      if (item.viewtype === 1) {
        if (item.pid) {
          return '/#!/notice/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&ext=1'
        } else {
          return '/#!/notice/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&ext=1'
        }
      }
      if (item.viewtype === 2) {
        return item.viewurl
      }
      if (item.viewtype === 3) {
        return item.downloadurl
      }
      if (item.viewtype === 4) {
        return '/#!/imgview?stype='+ this.stype + '&pdate=' + item.publishDate + '&id=' + item.id + '&ext=1'
      }
    },
    goLogin: function () {
      if (this.currentuser) {
        this.showModal = true
      } else {
        this.$route.router.go({path: '/login', query: {'uri': encodeURIComponent(window.location.href)}})
      }
    },
    fileIcon (fileext) {
      if (fileext === 'pdf') {
        return 'pdf-icon'
      }
      if (fileext === 'docx' || fileext === 'doc') {
        return 'dov-icon'
      }
      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
        return 'html-icon'
      }
      if (fileext === 'xls' || fileext === 'xlsx') {
        return 'xsl-icon'
      }
    },
    /**
     * 搜索条件-手风琴切换效果
     */
    slideDropdownMenu (event) {
      $('.sxtj').slideToggle('normal')   // 绑定slideToggle()函数
      // 判断图标节点是否有close or open类名，依据此切花图标样式
      let el = event.currentTarget
      let iconDom = el.lastElementChild
      let iconClass = iconDom.getAttribute('class'),
        class1 = iconClass.split(' ')[0],
        class2 = iconClass.split(' ')[1]
      if (class2 === 'close') {
        let classfr = 'fr';
        let _class = classfr + ' ' + 'open'
        iconDom.setAttribute('class', _class)
        this.setCnzz('[Mobile]-信披搜索', '查看筛选条件', '')
      }
      if (class2 === 'open') {
        let classf3 = 'f3'
        let _class = classf3 + ' ' + 'close'
        iconDom.setAttribute('class', _class)
        this.setCnzz('[Mobile]-信披搜索', '收起筛选条件', '')
      }
    },
    slideToggleTag: function () {
      $('.cpwtag').slideToggle('normal')
    },
    /**
     * 自定义下拉框
     * @param param - 字符串，用于确定打开的是哪一个下拉框
     */
    slideToggle (param) {
      if (this.showDropdownMenu === '') {
        this.showDropdownMenu = param
        // 点击下拉容器内，隐藏下拉
        $('.slide-menu').click(function () {
          this.showDropdownMenu = ''
          $(this).css({'display': 'none'})
        })
      } else {
        this.showDropdownMenu = ''
      }
    },
    log (str) {
      console.log(str)
    },
    hideDateModal (e) {
      let _con = $('#Release-date')
      // 判断点击是否发生在空白区域
      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
        this.showDateModal = false
      }
    },
    /**
     * 自定义下拉框
     * @param param - 字符串，用于确定打开的是哪一个下拉框
     */
    slideDropdown (param) {
      if (this.showDropdownMenu === '') {
        this.showDropdownMenu = param
        // 点击下拉容器内，隐藏下拉
        $('.slide-menu').click(function () {
          this.showDropdownMenu = ''
          $(this).css({'display': 'none'})
        })
      } else {
        this.showDropdownMenu = ''
      }
    },
    hideKeywordDropdown () {
      let el = $('.date-menu')
      if (el.hasClass('open')) {
        el.removeClass('open').addClass('close')
      }
    },
    /**
     * 筛选条件——点击确认按钮
     * @param type - 类型
     * @param date - 选中的类型
     */
    setSelectCondition (type, date) {
      console.log(this.conditions)
      console.log(date)
      if (type === 'select_type') {
        this.select_type = Object.keys(date)  // 获取属性名，返回一个数组
      }
      if (type === 'select_qaType') {
        this.select_qaType = Object.keys(date)
      }
      if (type === 'select_plate') {
        console.log(date)
        let select_plate = []
        for (let key in this.conditions['plate']) {
          select_plate.push(this.conditions['plate'][key])
        }
        this.select_plate = select_plate
        this.select_layer = Object.keys(this.conditions['layer'])
      }
      if (type === 'select_region') {
        this.select_region = Object.keys(date)
      }
      if (type === 'select_securityCompany') {
        this.select_securityCompany = Object.keys(date)
      }
      if (type === 'select_industry') {
        console.log(date)
        let select_industry = []
        let select_industrysecond = []
        for (let key in this.conditions['industry']) {
          select_industry.push(this.conditions['industry'][key])
        }
        for (let item in this.conditions['industrysecond']) {
          select_industrysecond.push(this.conditions['industrysecond'][item])
        }
        this.select_industry = select_industry
        this.select_industrysecond = select_industrysecond
      }
    },
    /**
     * 发布日期——点击确认按钮
     */
    confirmDate () {
      this.oldDatetype = this.datetype   // 日期类型
      this.oldStartdate = this.startdate
      this.oldEnddate = this.enddate
    },
    /**
     * 发布日期——点击取消按钮
     */
    cancelDate () {
      this.datatype = this.oldDatetype
      this.startdate = this.oldStartdate
      this.enddate = this.oldEnddate
    },
    /**
     * 切换筛选条件子类显示或隐藏
     * @param param
     */
    slideToggleFilter (param, event) {
      let id = '#' + param
      let el = event.currentTarget   // 当前事件对象
      $(id).slideToggle('normal')   // slow, normal, fast

      let elClass = el.getAttribute('class'),
        class1 = elClass.split(' ')[0],
        class2 = elClass.split(' ')[1],
        class3 = elClass.split(' ')[2],
        class4 = elClass.split(' ')[3]

      if (class4 === 'close') {
        let _class = class1 + ' ' + class2 + ' ' + class3 + ' ' + 'open'
        el.setAttribute('class', _class);
      }
      if (class4 === 'open') {
        let _class = class1 + ' ' + class2 + ' ' + class3 + ' ' + 'close'
        el.setAttribute('class', _class);
      }
    },
    /**
     * 清空板块类型
     */
    clearPlate () {
      for (var i = 0; i < this.plates.length; ++i) {
        this.plates[i].count = 0
      }
      this.conditions['plate'] = {}
      this.conditions['layer'] = {}
      let plates = ['SZZB', 'SZZXB', 'SZCYB', 'SHZB', 'N3BTS']
      for (let i of plates) {
        this.pageshowConditions['plate'][i] = ''
      }
      this.pageshowConditions['plate']['挂牌公司'] = []
      this.select_plate = []
      this.select_layer = []
    },
    /**
     * 清空行业类型
     */
    clearIndustry () {
      for (var i = 0; i < this.industry.length; ++i) {
        this.industry[i].count = 0
      }
      this.conditions['industry'] = {}   // 行业类型
      this.conditions['industrysecond'] = {}   // 行业子类
      for (let k in this.pageshowConditions['industry']) {
        this.pageshowConditions['industry'][k] = []
      }
      this.select_industry = []  // 选中的
      this.select_industrysecond = []
    },
    backToHistory () {
      window.history.back()
    }
  },
  watch: {
    'startdate': function () {  // 检测日期是否改变，若同时又时自定义就执行自定义筛选的函数
      if (this.datetype_name === '自定义') {
        this.sortByDate(99)
      }
    },
    'enddate': function () {
      if (this.datetype_name === '自定义') {
        this.sortByDate(99)
      }
    },
    'stype': function () {
      let sp = this.stype
      if (sp === 1) {
        this.stypename = 'A股'
      } else if (sp === 2) {
        this.stypename = '新三板'
      } else if (sp === 3) {
        this.stypename = '债券'
      } else if (sp === 5) {
        this.stypename = '问题库'
      } else if (sp === 6) {
        this.stypename = '港股'
      } else {
        this.stypename = sp
      }
    }
  },
  filters: {
    formatTypeName (param) {
      if (param === 1) {
        return 'A股'
      }
      if (param === 2) {
        return '新三板'
      }
      if (param === 3) {
        return '债券'
      }
      if (param === 4) {
        return '知识库'
      }
      if (param === 5) {
        return '问题库'
      }
      if (param === 6) {
        return '港股'
      }
      if (param === 7) {
        return '法院公告'
      }
      if (param === 8) {
        return '裁判文书'
      }
      if (param === 9) {
        return '政府公告'
      }
      if (param === 10) {
        return 'ABS'
      } 
      if (param === 11) {
        return '研报';
      }
      if (param === 12) {
        return '新闻';
      }
      if (param === 15) {
        return '我的文档';
      }
      if(param = 100){
        return '综合'
      }
      if(param == 13){
        return '研报数据'
      }

      
    },
    formatKeywords (param) {
      if (param.length > 10) {
        return param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 10) + '...'
      } else {
        return param
      }
    },
    formatNumber (z) {
      // return  Number(param).toLocaleString('en-US');
      if (!z) {
        return z
      } else {
        let num = z.toString()
        let normdata = ''
        if (num.indexOf('.') !== -1) {
          normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
            return $1 + ","
          })

        } else {
          normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function($0, $1) {
            return $1 + ","
          })
        }
        if (normdata.indexOf('.') >= 0) {
          let arr = normdata.split('.')
          if (arr[1].length < 2) {
            return normdata + '0'
          } else {
            return normdata.substr(0, normdata.indexOf('.') + 3)
          }
          // return arr[0] + '.' + arr[1]
        } else {
          return normdata
        }
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/searchResMix.js
 **/